<template>
  <div>
    <div v-if="request_prefix === 'bigScreen'">
      <ul class="swiper-styles">
        <li
          class="swiper-style-item"
          @click="changeSwiperStyle(style, index)"
          v-for="(style, index) in showStyles"
          :class="style.options.styleId && style.options.styleId === options.styleId ? 'active' : ''"
          :key="index"
        >
          <div class="chart_style_img_box">
            <img class="chart_style_img" :src="style.cover || barImgs[index]" alt="" />
            <span
              v-if="hasDelPermission && style.options.isSystemComponent"
              class="delete-icon"
              @mousedown.stop
              @click.stop="delComponent(style.options)"
              ><i class="icon icon-portal-delete"></i
            ></span>
            <i class="icon-checked" v-if="request_prefix !== 'bigScreen'"></i>
          </div>
          <p class="style_title">{{ style.name }}{{style.styleId}}</p>
        </li>
      </ul>
      <!-- <div v-if="swiperStyles.length > 0" class="more-btn" @click="showAllStyles">更多</div> -->
      <el-collapse class="expand-el-collapse bar-list-box" v-model="activeNames" v-if="request_prefix === 'bigScreen' && moreStyles.length > 0">
        <el-collapse-item :title="activeNames.length > 0 ? '收起' : '展开'" name="1">
          <ul class="swiper-styles">
            <li
              class="swiper-style-item"
              @click="changeSwiperStyle(style, index + showLen)"
              v-for="(style, index) in moreStyles"
              :class="style.options.styleId && style.options.styleId === options.styleId ? 'active' : ''"
              :key="index + showLen"
            >
              <!-- <img class="chart_style_img" :src="barImgs[index + showLen]" alt="" />
              <p class="style_title" :class="request_prefix === 'bigScreen' ? '' : 'home_style_title'">
                样式{{ showLen + index + 1 }}
              </p> -->
              <div class="chart_style_img_box">
                <img class="chart_style_img" :src="barImgs[index + showLen]" alt="" />
                <span
                  v-if="hasDelPermission && style.options.isSystemComponent"
                  class="delete-icon"
                  @mousedown.stop
                  @click.stop="delComponent(style.options)"
                  ><i class="icon icon-portal-delete"></i
                ></span>
                <i class="icon-checked" v-if="request_prefix !== 'bigScreen'"></i>
              </div>
              <p class="style_title">{{ style.name }}</p>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <local-style
      v-else
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxSwiper3D"
      :styleImgs="homeImgs"
      ref="localStyleComponent"
    />
    <!-- <styles-list
      :showDialog.sync="showAllStyle"
      :typeId="typeId"
      styleTypeName="轮播"
      :allStyles="swiperStyles"
      @changeStyle="changeSwiperStyle"
    ></styles-list> -->
    <!--    <el-collapse class="expand-el-collapse" v-model="activeNames" v-if="moreStyles.length > 0">-->
    <!--      <el-collapse-item :title="activeNames.length > 0 ? '收起' : '展开'" name="1">-->
    <!--        <ul class="swiper-styles flex">-->
    <!--          <li-->
    <!--            class="swiper-style-item"-->
    <!--            @click="changeSwiperStyle(style, index + showLen)"-->
    <!--            :class="activeIndex === index + showLen ? 'active' : ''"-->
    <!--            v-for="(style, index) in moreStyles"-->
    <!--            :key="index + showLen"-->
    <!--          >-->
    <!--            <div class="chart_style_img_box">-->
    <!--              <img class="chart_style_img" :src="barImgs[index + showLen] || style.cover" alt="" />-->
    <!--              <span-->
    <!--                v-if="hasDelPermission && style.isSystemComponent"-->
    <!--                class="delete-icon"-->
    <!--                @mousedown.stop-->
    <!--                @click.stop="delComponent(style.options)"-->
    <!--                ><i class="icon icon-portal-delete"></i-->
    <!--              ></span>-->
    <!--            </div>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </el-collapse-item>-->
    <!--    </el-collapse>-->
  </div>
</template>

<script>
import instance from "@/interceptor"
import stylesList from "toolbarComponents/styles/styles-list"
import { getModulesList, initStageModules } from "@/utils/initEv.js"
import localStyle from "toolbarComponents/styles/local-style.vue"

export default {
  name: "swiper-options-style",
  components: { stylesList,localStyle },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    typeId() {
      return this.options.componentTypeId
    },
    hasDelPermission() {
      let userPermissionCode = this.$store.state.states.userPermission || ""
      return Array.isArray(userPermissionCode)&& userPermissionCode?.indexOf(12) > -1 ? true : false
    },
    swiperStyles() {
      let state = this.request_prefix === "bigScreen" ? "bigScreenMenu" : this.request_prefix === "appStage" ? "appMenu" : "menu"
      let menu = this.$store.state[state].menu
      let styles = [],
        stylesOption = []
      for (let i = 0; i < menu.children.length; i++) {
        if (menu.children[i].type === "element") {
          for (let j = 0; j < menu.children[i].children.length; j++) {
            if (menu.children[i].children[j].type === "cxSwiper3D") {
              styles = menu.children[i].children[j].children
              break
            }
          }
          break
        }
      }
      styles.forEach(item => {
        stylesOption.push({
          options: item.attribute.options,
          name: item.name,
          cover: item.cover
        })
      })
      return stylesOption
    },
    showStyles() {
      return this.swiperStyles.length > this.showLen ? this.swiperStyles.slice(0, this.showLen) : this.swiperStyles
    },
    moreStyles() {
      return this.swiperStyles.length > this.showLen ? this.swiperStyles.slice(this.showLen) : []
    },
    getChartStyle() {
      if (this.options) {
        return {
          height: this.options.height + "px",
          transform: "rotate(" + this.options.rotate + "deg)"
        }
      } else return null
    }
  },
  data() {
    return {
      activeIndex: undefined,
      activeNames: [],
      showLen: 6,
      barImgs: [
        require("../../../assets/images/leftMenu/swiper3D/swiper1.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper2.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper3.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper4.png"),
      ],
      homeImgs: [
        require("../../../assets/images/leftMenu/swiper3D/swiper1.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper2.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper3.png"),
        require("../../../assets/images/leftMenu/swiper3D/swiper4.png"),
      ],
      showAllStyle: false
    }
  },
  methods: {
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    },
    changeSwiperStyle(style, index) {
      if (this.request_prefix !== "bigScreen" && typeof index !== undefined) {
        this.activeIndex = index
      }
      let tmpData = JSON.parse(JSON.stringify(style)).options
      let curOptions = this.getRectAttribute.call(this, this.ids).options
      tmpData.left = curOptions.left
      tmpData.top = curOptions.top
      tmpData.width = curOptions.width
      tmpData.height = curOptions.height
      // tmpData.content = curOptions.content
      if (curOptions.appId) {// 保留数据源
        tmpData.appId = curOptions.appId
        tmpData.moduleId = curOptions.moduleId
        tmpData.myFetchParam = curOptions.myFetchParam
        tmpData.engineInstanceId = curOptions.engineInstanceId
        tmpData.engineInstanceAppId = curOptions.engineInstanceAppId
      }
      let data = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
      if (curOptions.appId) {
        let nowComp = this.$event.contexts.stage[this.$event.getIdsByStrId(this.ids)]
        nowComp.updateData()
      }
      // 切换轮播样式需要更新图层数据：解决轮播切换样式后数据不更新的情况
      this.$store.commit("states/changeIsUpdateLayerDataFlag", true)
    },
    delComponent(param) {
      const self = this
      if (param.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${param.encId}/remove`)
              .then(() => {
                getModulesList.call(self, { id: this.typeId })
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-styles {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.swiper-style-item {
  position: relative;
  display: inline-block;
  width: calc((100% - 16px)/3);
  margin-right: 8px;
  margin-bottom: 12px;
  border-radius: 4px;
  cursor: pointer;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .chart_style_img_box {
    position: relative;
    width: 100%;
    height: 52px;
    border: 2px solid;
    box-sizing: content-box;
    border-color: transparent;
    border-radius: 4px;
    background-color: var(--styleBgColor);
    .chart_style_img {
      width: 100%;
      height: 100%;
    }
    .delete-icon {
      position: absolute;
      display: none;
      bottom: 4px;
      right: 4px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
    }
    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }
    &:hover {
      .delete-icon {
        display: block;
      }
    }
  }
  &:hover {
    .chart_style_img_box {
      border-color: rgba(23, 112, 255, 0.3);
    }
  }
  &.active {
    .chart_style_img_box {
      border-color: var(--themeColor);
      .icon-checked {
        display: block;
      }
    }
    .style_title {
      color: var(--text);
    }
  }
}
.style_title {
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--text);
}
.swiper-style-item:last-child {
  margin-right: 0;
}
.more-btn {
  margin: 8px auto;
  text-align: center;
  font-size: 14px;
  color: var(--themeColor);
  cursor: pointer;
}
</style>
